import { useQuery } from '@tanstack/react-query';
import { getObraCustosAgregados } from '../services/api';

export interface CustoAgregado {
    id: number;
    nome: string;
    total: number;
    percentual: number;
}

export const useObraCustos = (
    obraId: string | undefined,
    groupBy: string,
    categoriaPaiId?: number,
    enabled: boolean = true
) => {
    const {
        data: custos,
        isLoading: loading,
        error,
        refetch
    } = useQuery({
        queryKey: ['obra-custos', obraId, groupBy, categoriaPaiId],
        queryFn: () => getObraCustosAgregados(Number(obraId), groupBy, categoriaPaiId),
        enabled: enabled && !!obraId,
    });

    return {
        custos: custos || [],
        loading,
        error: error ? (error as Error).message : null,
        refetch
    };
};
